module.exports = __webpack_public_path__ + "img/logo-balmain.87223061.jpg";